import './DatesSelector.scss'
import React, { useEffect, useRef, useState } from "react";
import { usePickerContext } from "../hooks/usePickerContext";

export const DatesSelector = ({ disabled }) => {

    const { state: { dates }, dispatch } = usePickerContext();

    const dateRef = useRef();
    const hourRef = useRef();
    const [selectedItem, setSelectedItem] = useState({ uuid: Math.random() });

    const currentDate = dates.find(date => date.current);

    let currentHoursValue;
    if (currentDate) {
        currentHoursValue = Object.keys(currentDate.hours).find(value => currentDate.hours[value].current);
    }

    const dateComponent = disabled ? (
        <div className={"DatesSelector-disabled"}>
            <span>Date : </span>
            <span>{currentDate.label}</span>
        </div>
    ) : (
        <select ref={dateRef} className={'SeatsPickerInitiator-select'} value={currentDate ? currentDate.at : ''} onChange={e => onSelectValue(e, 'DATE')}>
            {dates.map((date, index) =>
                <option key={index} value={date.at}>{date.label}</option>
            )}
        </select>
    )

    function onSelectDate(e) {
        const selected = dates.find(date => date.at === selectedItem.value);
        dispatch({ type: 'SET_CURRENT_DATE', payload: selected });
    }

    function onSelectHours(e){
        // console.log(selectedItem.value)
        // console.log(Object.keys(currentDate.hours))
        const selected = Object.keys(currentDate.hours).find(value => value === selectedItem.value);
        dispatch({ type: 'SET_CURRENT_HOUR', payload: selected });
    }

    function onSelectValue(e, type) {
        // On enlève le chargement automatique au changement du select
        // Obligation de cliquer sur le bouton Rechercher
        // dispatch({ type: 'SET_LOADING', payload: true });
        setSelectedItem({
            uuid: Math.random(),
            value: e.target.value,
            type
        });
    }

    function onDatesChange() {
        if (!!dateRef.current?.options.length) {
            const selectedValue = dateRef.current.options[dateRef.current.selectedIndex].value
            const selected = dates.find(date => date.at === selectedValue);
            dispatch({ type: 'SET_CURRENT_DATE', payload: selected });
        }
        if (!!hourRef.current?.options.length) {
            dispatch({ type: 'SET_CURRENT_HOUR', payload: hourRef.current.options[hourRef.current.selectedIndex].value });
        }
    }

    function onSelectedValueChange() {
        switch (selectedItem.type) {
            case 'DATE': {
                onSelectDate();
                break;
            }
            case 'HOUR': {
                onSelectHours();
                break;
            }
        }
    }

    useEffect(onDatesChange, [dates]);
    useEffect(onSelectedValueChange, [selectedItem.uuid]);

    return (
        <div className={"DatesSelector"}>
            {dateComponent}
            {!!currentDate && (
                <select ref={hourRef} className={`SeatsPickerInitiator-select ${Array.isArray(currentDate.hours) ? 'is-array' : ''}`} value={currentHoursValue} onChange={e => onSelectValue(e, 'HOUR')}>
                    {Object.keys(currentDate.hours).map((value, index) =>
                        <option key={index} value={value}>{currentDate.hours[value].label}</option>
                    )}
                </select>
            )}
        </div>
    )
};